module.exports = __webpack_public_path__ + "img/dell-logo.cbf6687e.svg";